/** Helpers de tributação por item da NF-e gerencial. */

import { parseBRLToNumber, parseBRLToNumberOrZero } from './decimalBr';

const num = (v) => {
  if (v === '' || v == null) return 0;
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  const brl = parseBRLToNumber(v);
  if (brl !== null) return brl;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export const numOrNull = (v) => {
  if (v === '' || v == null) return null;
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  const brl = parseBRLToNumber(v);
  if (brl !== null) return brl;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

export const itemValorLiquido = (it) =>
  Math.round((num(it.qCom) * num(it.vUnCom) - num(it.vDesc) + num(it.vOutro)) * 100) / 100;

export const defaultTributosExtras = () => ({
  modBc: 3,
  pRedBc: '',
  vBc: '',
  pIcms: '',
  vIcms: '',
  pCredSn: '',
  vCredIcmsSn: '',
  modBcSt: '',
  pMvaSt: '',
  pRedBcSt: '',
  vBcSt: '',
  pIcmsSt: '',
  vIcmsSt: '',
  cBenef: '',
  pFcp: '',
  vFcp: '',
  pFcpSt: '',
  vFcpSt: '',
  vBcUfDest: '',
  pFcpUfDest: '',
  pIcmsUfDest: '',
  pIcmsInter: '',
  pIcmsInterPart: '100',
  vFcpUfDest: '',
  vIcmsUfDest: '',
  vIcmsUfRemet: '',
  vBcIpi: '',
  pIpi: '',
  vIpi: '',
  vBcPis: '',
  pPis: '',
  vPis: '',
  vBcCofins: '',
  pCofins: '',
  vCofins: '',
});

export const tributosFromGrupo = (g = {}) => ({
  ...defaultTributosExtras(),
  modBc: 3,
  modBcSt: g.substituicaoTributaria ? 4 : '',
  cstIpi: g.ipi ?? 99,
  cstPis: g.pis ?? 99,
  cstCofins: g.cofins ?? 99,
  pIcms: g.aliquotaIcms ?? '',
  pIpi: g.aliquotaIpi ?? '',
  pPis: g.aliquotaPis ?? '',
  pCofins: g.aliquotaCofins ?? '',
});

export const aplicarDefaultsTributos = (it) => {
  const vItem = itemValorLiquido(it);
  const next = { ...it };
  if (next.modBc === '' || next.modBc == null) next.modBc = 3;
  if (next.vBc === '' || next.vBc == null) next.vBc = vItem;
  const vBc = num(next.vBc);
  const pIcms = num(next.pIcms);
  if ((next.vIcms === '' || next.vIcms == null) && vBc > 0 && pIcms > 0) {
    next.vIcms = Math.round(vBc * pIcms / 100 * 100) / 100;
  }
  const pIpi = num(next.pIpi);
  if ((next.vBcIpi === '' || next.vBcIpi == null) && pIpi > 0) next.vBcIpi = vItem;
  const vBcIpi = num(next.vBcIpi);
  if ((next.vIpi === '' || next.vIpi == null) && vBcIpi > 0 && pIpi > 0) {
    next.vIpi = Math.round(vBcIpi * pIpi / 100 * 100) / 100;
  }
  const pPis = num(next.pPis);
  if ((next.vBcPis === '' || next.vBcPis == null) && pPis > 0) next.vBcPis = vItem;
  const vBcPis = num(next.vBcPis);
  if ((next.vPis === '' || next.vPis == null) && vBcPis > 0 && pPis > 0) {
    next.vPis = Math.round(vBcPis * pPis / 100 * 100) / 100;
  }
  const pCofins = num(next.pCofins);
  if ((next.vBcCofins === '' || next.vBcCofins == null) && pCofins > 0) next.vBcCofins = vItem;
  const vBcCofins = num(next.vBcCofins);
  if ((next.vCofins === '' || next.vCofins == null) && vBcCofins > 0 && pCofins > 0) {
    next.vCofins = Math.round(vBcCofins * pCofins / 100 * 100) / 100;
  }
  return next;
};

export const mapTributosPayload = (i) => ({
  modBc: numOrNull(i.modBc),
  pRedBc: numOrNull(i.pRedBc),
  vBc: numOrNull(i.vBc),
  pIcms: numOrNull(i.pIcms ?? i.aliquotaIcms),
  vIcms: numOrNull(i.vIcms),
  pCredSn: numOrNull(i.pCredSn),
  vCredIcmsSn: numOrNull(i.vCredIcmsSn),
  modBcSt: numOrNull(i.modBcSt),
  pMvaSt: numOrNull(i.pMvaSt),
  pRedBcSt: numOrNull(i.pRedBcSt),
  vBcSt: numOrNull(i.vBcSt),
  pIcmsSt: numOrNull(i.pIcmsSt),
  vIcmsSt: numOrNull(i.vIcmsSt),
  cBenef: i.cBenef ? String(i.cBenef).trim() : null,
  pFcp: numOrNull(i.pFcp),
  vFcp: numOrNull(i.vFcp),
  pFcpSt: numOrNull(i.pFcpSt),
  vFcpSt: numOrNull(i.vFcpSt),
  cstIpi: i.cstIpi == null || i.cstIpi === '' ? 99 : Number(i.cstIpi),
  vBcIpi: numOrNull(i.vBcIpi),
  pIpi: numOrNull(i.pIpi),
  vIpi: numOrNull(i.vIpi),
  cstPis: i.cstPis == null || i.cstPis === '' ? 99 : Number(i.cstPis),
  vBcPis: numOrNull(i.vBcPis),
  pPis: numOrNull(i.pPis),
  vPis: numOrNull(i.vPis),
  cstCofins: i.cstCofins == null || i.cstCofins === '' ? 99 : Number(i.cstCofins),
  vBcCofins: numOrNull(i.vBcCofins),
  pCofins: numOrNull(i.pCofins),
  vCofins: numOrNull(i.vCofins),
  vBcUfDest: numOrNull(i.vBcUfDest),
  pFcpUfDest: numOrNull(i.pFcpUfDest),
  pIcmsUfDest: numOrNull(i.pIcmsUfDest),
  pIcmsInter: numOrNull(i.pIcmsInter),
  pIcmsInterPart: numOrNull(i.pIcmsInterPart),
  vFcpUfDest: numOrNull(i.vFcpUfDest),
  vIcmsUfDest: numOrNull(i.vIcmsUfDest),
  vIcmsUfRemet: numOrNull(i.vIcmsUfRemet),
});
